// Encart publicitaire pour les pages de contenu éditorial (guides).
// Placé uniquement sur des pages indexables avec du vrai contenu texte,
// jamais sur les écrans interactifs de l'app (leçons, quiz, jeux).
import React, { useEffect, useRef } from 'react';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

const AD_CLIENT = 'ca-pub-5019512446625306';
const AD_SLOT = '6550307535';

const GuideAdSlot: React.FC = () => {
  const adRef = useRef<HTMLModElement>(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch {
      // AdSense indisponible (bloqueur de pub, dev local, etc.)
    }
  }, []);

  return (
    <div style={{ margin: '2rem 0', textAlign: 'center' }}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={AD_SLOT}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default GuideAdSlot;
